export class NumberIncrementer {
    private _options: NumberIncrementerOptions;

    private _count: number;
    private _increment: number;
    private _interval;
    private _regex = /\B(?=(\d{3})+(?!\d))/g;

    constructor(options: NumberIncrementerOptions) {
        this._options = options;

        // set data-attribute options
        if (this._options.value <= 0) {
            this._options.value = parseFloat(this._options.el.getAttribute("data-inc-value")) || 0;
        }
        this._options.duration = parseFloat(this._options.el.getAttribute("data-inc-duration")) || 0;
        this._options.delay = parseFloat(this._options.el.getAttribute("data-inc-delay")) || 0;
        this._options.decimal = (this._options.decimal > 2 ? 2 : this._options.decimal) || 0;
        this._options.speed = (this._options.speed < 30 ? 30 : this._options.speed) || 30;
        this._increment = this._options.value / (this._options.duration / this._options.speed);
        this._interval = null;
        this._count = 0;

        // run
        setTimeout(
            function () {
                this._interval = setInterval(this.run.bind(this), this._options.speed);
            }.bind(this),
            this._options.delay
        );
    }

    private run(): void {
        this._count += this._increment;
        if (this._count < this._options.value) {
            this._options.el.innerHTML = this._count.toFixed(this._options.decimal).toString().replace(this._regex, ",")
        } else {
            clearInterval(this._interval);
            this._options.el.innerHTML =
                this._options.value.toFixed(this._options.decimal).toString().replace(this._regex, ",")
        }
    }
}

type NumberIncrementerOptions = {
    el: HTMLElement;
    speed: number;

    // set by data-attributes
    value?: number;
    duration?: number;
    delay?: number;
    decimal?: number;
}